import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import { Link } from "react-router-dom";
import axios from "axios";
import { errorToast } from "../../../Components/ToastMessage";
import moment from "moment/moment";

const CompletedInterviews = () => {
  const [completedInterviews, setCompletedInterviews] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get("/interviews/completed");
        if (response.data) {
          setCompletedInterviews(response.data);
        }
      } catch (error) {
        errorToast(error.message);
      }
    })();
  }, []);

  return (
    <DashboardLayout>
      <div className="bg-gray-100 overflow-auto h-full p-6">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Completed Interviews
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {completedInterviews.map((interview) => (
            <div
              key={interview._id}
              className="bg-white shadow-md rounded-lg p-6 border-t-4 border-slate-500"
            >
              <h2 className="text-xl font-semibold text-gray-700 mb-2">
                {interview.candidate?.name}
              </h2>

              <p className="text-gray-600 mb-1">
                <strong>Position:</strong> {interview.position?.name}
              </p>

              <p className="text-gray-600 mb-1">
                <strong>Interviewer:</strong> {interview.interviewer?.name}
              </p>

              <p className="text-gray-600 mb-4">
                <strong>Date:</strong>{" "}
                {moment.utc(interview.date).format("YYYY-MM-DD")}{" "}
                {moment
                  .utc(
                    `${interview.date.split("T")[0]}T${interview.time}:00+00:00`
                  )
                  .format("hh:mm a")}
              </p>

              <Link
                to={`/interview-completed/${interview._id}`}
                className="bg-slate-500 text-white px-4 py-2 rounded-md hover:bg-slate-600 transition"
              >
                View Details
              </Link>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CompletedInterviews;
